import { ClientWebPage } from '../meta/clientWebPage';
import { BlockField, BlockTemplate, CatalogPlaces, REF_KEY } from './const';
import { BlockConfig } from './types';

export const blockRoutePlaceConfig: Partial<Record<ClientWebPage, string[]>> = {
  [ClientWebPage.Catalog]: [CatalogPlaces.infoContent],
};

export const blockTemplateConfig: BlockConfig = {
  [BlockTemplate.primaryInfoContent]: {
    heading: {
      field: BlockField.text,
      default: '',
    },
    content: {
      field: BlockField.editor,
      default: '',
    },
  },
  [BlockTemplate.reference]: {
    [REF_KEY]: {
      field: BlockField.reference,
    },
  },
};
